// tslint:disable
/**
 * CONEXSYS Lead Portal API
 * The API for the CONEXSYS Lead Portal
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: support@conexsys.com
 *
 * EVENT: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { leadConfig as config } from '../../../config/lead';
import { apiRequest, setEntitiesApiOperationState } from '../../../app/api';
import { EventHelper } from '../classes';
import moment from 'moment';
import _ from 'lodash';

import { EventEntity, EventEntities } from '../collections';
import { State_ApiOperationContextTypes } from '../../../storage';
import { UseCtx } from '../../../config/hooks';
import { modifyEntity } from '../../../app/utils';
import axios from 'axios';

export enum EventApiOperation {
	readEvents = 'readEvents',
	readEventsAll = 'readEventsAll',
	writeEvents = 'writeEvents'
}

export interface ReadEventsRequest {
	userId: string;
	queryLimit?: number;
	queryBookmark?: string;
	modifiedFrom?: string;
	modifiedTo?: string;
	ids?: string[];
}

export interface ReadEventsAllRequest {
	userId: string;
	queryLimit?: number;
	queryBookmark?: string;
	modifiedFrom?: string;
	modifiedTo?: string;
	ids?: string[];
}

export interface WriteEventsRequest {
	userId: string;
	events: EventEntities;
}

/**
 * Read events
 */
export async function readEvents(
	ctx: UseCtx<any>,
	requestParameters: ReadEventsRequest
): Promise<EventEntities> {
	const operationId = EventApiOperation.readEvents,
		requestId = 'default';

	// get the attempt date now BEFORE the request is made so there is no GAP in time if the request takes awhile or fails
	const attemptDate: string = moment().toISOString();

	// make the api request
	const response = await apiRequest<EventEntities, ReadEventsRequest>(
		ctx,
		config.apiId,
		operationId,
		requestParameters
	);

	let entities: EventEntities | undefined = response.response.data;
	if (!entities) entities = [];

	// patch entities states with an api success data for the operation
	setEntitiesApiOperationState<EventEntities, EventHelper>(
		ctx.lead.event,
		entities,
		operationId,
		requestId,
		State_ApiOperationContextTypes.Success,
		attemptDate
	);

	// upsert the entities to the store
	ctx.lead.event.upsert(entities);

	// return the entities to the caller for direct reference
	return entities;
}

/**
 * Read All events
 */
export async function readEventsAll(
	ctx: UseCtx<any>,
	requestParameters: ReadEventsAllRequest
): Promise<EventEntities> {
	const operationId = EventApiOperation.readEventsAll,
		requestId = 'default';

	// get the attempt date now BEFORE the request is made so there is no GAP in time if the request takes awhile or fails
	const attemptDate: string = moment().toISOString();

	// make the api request
	const response = await apiRequest<EventEntities, ReadEventsAllRequest>(
		ctx,
		config.apiId,
		operationId,
		requestParameters
	);

	let entities: EventEntities | undefined = response.response.data;
	if (!entities) entities = [];

	// patch entities states with an api success data for the operation
	setEntitiesApiOperationState<EventEntities, EventHelper>(
		ctx.lead.event,
		entities,
		operationId,
		requestId,
		State_ApiOperationContextTypes.Success,
		attemptDate
	);

	// upsert the entities to the store
	ctx.lead.event.upsert(entities);

	// return the entities to the caller for direct reference
	return entities;
}

/**
 * Write Events
 */
export async function writeEvents<T>(
	ctx: UseCtx<any>,
	requestParameters: WriteEventsRequest
): Promise<EventEntities> {
	const operationId = EventApiOperation.writeEvents,
		requestId = 'default';

	// get the attempt date now BEFORE the request is made so there is no GAP in time if the request takes awhile or fails
	const attemptDate: string = moment().toISOString();

	// update each entities modified info
	requestParameters.events.forEach(
		(entity: EventEntity, i: number, a: EventEntities) => {
			a[i] = modifyEntity<EventEntity>(ctx, entity);
		}
	);

	// make the api request
	const response = await apiRequest<EventEntities, WriteEventsRequest>(
		ctx,
		config.apiId,
		operationId,
		requestParameters,
		'events'
	);

	let entities: EventEntities | undefined = response.response.data;
	if (!entities) entities = [];

	// patch entities states with an api success data for the operation
	setEntitiesApiOperationState<EventEntities, EventHelper>(
		ctx.lead.event,
		entities,
		operationId,
		requestId,
		State_ApiOperationContextTypes.Success,
		attemptDate
	);

	// upsert the entities to the store
	ctx.lead.event.upsert(entities);

	// return the entities to the caller for direct reference
	return entities;
}
